<div id="dialog">
    <div>
        <h6 data-dialog-title class="viz-h6">{{data.title}}</h6>
    </div>
    <div class="viz-body-1"
         data-dialog-message
    [innerHTML]="data.message">
    </div>
    <div class="action-buttons" id="button-container">
        <button data-dialog-button (click)="navigateToBidManagement(bidManagementURL)"
                mat-stroked-button id="CloseButton"
                mat-dialog-close class="action-btns"
        >Close
        </button>
    </div>
</div>
